import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { colors } from '../common/constants';

export const StyledReview = styled(Container)`
  flex: 1;
  background-color: #fff;
`;

export const StyledBreadcrumb = styled.div`
  margin-top: 4px;
  margin-bottom: 16px;
  color: ${colors.primary};
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon {
    font-size: 1.3rem;
  }

  .left-breadcrumb {
    display: flex;
    align-items: center;
  }
`;

export const StyledCardTitle = styled.div`
  font-weight: 500;
  font-size: 1.3rem;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .icon {
    font-size: 1.3rem;
  }
`;

export const StyledCard = styled.div`
  background-color: #fff;
  border: 1px solid #eaded2;
  border-radius: 0.75rem;
  padding: 16px;
  margin-bottom: 16px;
  p {
    margin-bottom: 8px;
  }
`;
StyledCard.displayName = 'StyledCard';

export const StyledContactForm = styled(StyledCard)`
  background-color: ${colors.secondary};
`;

export const StyledDetailText = styled.div`
  margin-bottom: 4px;
`;

export const StyledReviewActions = styled.div`
  padding-top: 16px;
  padding-bottom: 32px;
`;

export const StyledReviewButtonText = styled.span`
  margin-left: 4px;
`;

export const StyledSummary = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  background-color: ${colors.secondary};
  font-size: 1.3rem;
  margin-top: 8px;
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: -16px;
  border-top: 1px solid #ccc;

  .price-subtext {
    font-size: 1rem;
    color: #888;
  }
`;

export const StyledPaymentMethodForm = styled(StyledCard)`
  .form-check {
    background: ${colors.secondary};
    padding: 1rem;
    padding-left: 3rem;
    border-radius: 0.5rem;
    margin: 6px 0;
  }

  .form-check-input {
    font-size: 1.4rem;
  }
`;

export const StyledPaymentIcon = styled.span`
  color: #8b0404;
  margin-right: 1rem;
  font-size: 1.6rem;
  line-height: 1;
`;

export const StyledReviewOriginalPrice = styled.div`
  text-decoration: line-through;
  font-size: 0.875rem;
  line-height: 0.875rem;
  text-align: right;
  color: darkgray;
`;
